import axios from "axios";
import { token, url } from "./Config";

const ADMIN_FOOD_READY_STATUS_IDS = [1, 2, 4, 5];

export const canAdminChangeFoodReady = (order) => ADMIN_FOOD_READY_STATUS_IDS.includes(order?.status?.id);

export const setFoodReady = async (orderId, ready) => {
  const data = new FormData();
  data.append("order_id", orderId);
  data.append("ready", ready ? "true" : "false");
  const response = await axios({
    method: "post",
    url: `${url}/partner/admin/food-ready/`,
    data,
    headers: { Authorization: token },
  });
  if (response.data?.Status !== true) throw new Error(response.data?.Error || "Could not save food ready");
  return response.data.food_ready_at ?? null;
};
